import * as Auth from "~/auth";
import * as autocomplete from "~/autocomplete";
import $ from "jquery";
import * as _ from "~/utils";
import UI from "~/ui";
import "~/globals";
import { t } from "~/hooks/useI18n";
import { gotoLogin } from "~/utils";
import { getApi, handleError } from "~/auth";
import * as validation from "~/utils/validation";
import { extractBirth, validateCodiceFiscale } from "~/utils/codicefiscale";
import { format } from "date-fns";
import Component from "~/components/Component";
import Page from "~/pages/Page";
import {AnagraficaError} from "@reteaste/reteaste-anagrafica-client";

class DatiAnagraficiError extends Component {
    constructor() {
        super("#errorMessage");
    }

    public showError(message: string) {
        $(this.domElement).html(message);
        $(this.domElement).removeClass("d-none");
        $(this.domElement).toggleClass("alert-success", false);
        $(this.domElement).toggleClass("alert-danger", true);
    }

    public showInfo(message: string) {
        $(this.domElement).html(message);
        $(this.domElement).removeClass("d-none");
        $(this.domElement).toggleClass("alert-danger", false);
        $(this.domElement).toggleClass("alert-success", true);
    }

    public hideError() {
        $(this.domElement).html("");
        $(this.domElement).addClass("d-none");
    }
}

interface DatiAnagraficiOptions {
    strictValidation?: boolean;
}

export class DatiAnagrafici {
    private theForm: HTMLFormElement = document.getElementById("frmProfilo") as HTMLFormElement;
    private userInfo: Auth.UserInfo = {} as Auth.UserInfo;
    private _eventsRegistered: boolean = false;
    private _strictValidation: boolean = true;
    private errorMessage: DatiAnagraficiError = new DatiAnagraficiError();

    constructor(opts?: DatiAnagraficiOptions) {
        this._strictValidation = opts?.strictValidation ?? true;
    }

    public async activate(): Promise<void> {
        const that = this;
        // RESETTO TUTTI I CAMPI
        const theForm = this.theForm;
        if (!theForm) {
            console.error("Form #frmProfilo non trovato");
            return;
        }

        // INIZIALIZZO I CAMPi
        if (!this._eventsRegistered) {

            // INIZIALIZZO LE COMBO AUTOCOMPLETE COMUNE
            autocomplete.autoCompleteComuni(
                false,
                "txtComune",
                "txtIdComune",
                "txtIdProvincia",
                "txtProvincia",
                "txtCap");

            autocomplete.autoCompleteComuni(
                true,
                "txtComuneNascita",
                "txtIdComuneNascita",
                null,
                null,
                null);


            // resetto i campi sull'edit del comune
            // Memorizzo il valore selezionato dall'autocomplete per confrontarlo
            let lastSelectedComune = "";

            // Quando l'autocomplete seleziona un comune, memorizziamo il valore
            $("#txtIdComune").on('change', function () {
                lastSelectedComune = $("#txtComune").val() as string;

                // Se lo stato di residenza non è valorizzato, impostiamo Italia
                const statoResidenza = $("#ddlStatoRes").val() as string;
                if (!statoResidenza || statoResidenza === "") {
                    $("#ddlStatoRes").val("100").trigger('change');
                }
            });

            // Resetta i campi solo se l'utente modifica manualmente il testo
            $("#txtComune").on('input', function () {
                const currentValue = $("#txtComune").val() as string;

                // Se il valore corrente è diverso dall'ultimo selezionato, resetta i campi
                if (currentValue !== lastSelectedComune) {
                    $("#txtIdComune").val("");
                    $("#txtIdProvincia").val("");
                    $("#txtProvincia").val("");
                    $("#txtCap").val("");
                    lastSelectedComune = "";
                }
            });

            // sincronizzazione campi cellulare
            $("#txtCellulare").on('change', function (e) {
               $("#txtHiddenCellulare").val($(this).val() as string); 
            });
            // sincronizzazione campi email
            $("#txtEmail").on('change', function (e) {
                $("#txtHiddenEmail").val($(this).val() as string);
            });

            // CAMPO CODICE FISCALE IN UPPERCASE
            $("#txtCodiceFiscalePrivato").on('keyup', function () {
                let cf = $(this).val() as string;
                $(this).val(cf.toUpperCase());
            })

            $("#txtCodiceFiscalePrivato").on('blur', function () {
                let cf = $(this).val() as string;
                that.aggiornaDatiDaCodiceFiscale(cf);
            })

            $("#ddlStatoNasc").on('change', function () {
                let idStato = _.coalesce($(this).val(), "") as string;

                // Se selezionato uno stato, rimuovi l'opzione vuota
                if (idStato !== "") {
                    $("#ddlStatoNasc option[value='']").remove();
                }

                that.setNascita(idStato !== "100" ? "estero" : "ita");
                that.updateFieldsRequirements();
            });

            $("#ddlStatoRes").on('change', function () {
                let idStato = _.coalesce($(this).val(), "") as string;

                // Se selezionato uno stato, rimuovi l'opzione vuota
                if (idStato !== "") {
                    $("#ddlStatoRes option[value='']").remove();
                }

                that.setResidenza(idStato !== "100" ? "estero" : "ita");
                that.updateFieldsRequirements();
            });

            $(theForm).find("input[name='optCittadinanza']").on('change', function (e) {
                let el = this as HTMLInputElement;
                console.log(this.id, el.checked ? "checked" : "unchecked", this);

                that.setCittadinanza(el.id === "optCittadinanzaItaliana" ? "ita" : "estero");
                that.updateFieldsRequirements();
            });

            $("#btnModificaEMail").on('click', function (e) {
                e.preventDefault();
                that.toggleVerificaEmail(true);
                that.saveUndoValueEmail();
                $("#txtEmail")
                    .val("")
                    .focus();
            });

            $("#btnAnnullaEMail").on('click', function (e) {
                e.preventDefault();
                that.toggleVerificaEmail(false);
                that.restoreValueEmail();
                validation.resetValidation("txtEmail");
            });

            $("#btnVerificaEMail").on('click', async function (e) {
                e.preventDefault();
                const _email = $("#txtEmail").val() as string;
                if (_email) {

                    if (await that.updateContattoEmail({
                        idContatto: ($("#txtIdContattoEMail").val() as number) || null,
                        tipoContatto: "MAIL",
                        verificato: false,
                        valore: $("#txtEmail").val(),
                    } as Auth.Contatto))
                        that.toggleVerificaEmail(false);
                } else {
                    UI.confirmOneButton("", t("messages.emailCannotBeEmpty"));
                }

            })

            $("#btnModificaCell").on('click', function (e) {
                e.preventDefault();
                that.toggleVerificaCellulare(true);
                that.saveUndoValueCellulare();
                $("#txtCellulare")
                    .val("")
                    .trigger("focus");
                $("#ddlPrefisso")
                    .val("0039");
            });

            $("#btnAnnullaCell").on('click', function (e) {
                e.preventDefault();
                that.toggleVerificaCellulare(false);
                that.restoreValueCellulare();
                validation.resetValidation("txtCellulare");
            });
            $("#btnVerificaCellulare").on('click', async function (e) {
                e.preventDefault();
                // that.toggleVerificaCellulare(true);

                const $cellulare = $("#txtCellulare");

                // Verifica che il campo non sia vuoto
                const cellulareVal = $cellulare.val() as string;
                if (!cellulareVal || cellulareVal.trim() === "") {
                    await UI.confirmOneButton("", t("messages.mobileCannotBeEmpty"));
                    $cellulare[0].focus();
                    return;
                }

                // // Verifica che il campo non abbia errori di validazione (già eseguiti all'input)
                // if (!$cellulare.hasClass("not-verified") && $cellulare.hasClass("is-invalid")) {
                //     await UI.confirmOneButton("", t("messages.mobileCannotBeEmpty"));
                //     $cellulare[0].focus();
                //     return;
                // }

                let contatto = {
                    tipoContatto: "CELL",
                    verificato: false,
                    prefisso: $("#ddlPrefisso").val() as string,
                    valore: $("#txtCellulare").val(),
                } as Auth.Contatto;
                let idContatto = $("#txtIdContattoCell").val() as number;
                if (idContatto > 0) contatto.idContatto = idContatto;


                if (await that.updateContattoCell(contatto)) {
                    that.toggleVerificaCellulare(false);
                }


            });

            // TEST PER CORS (rif. 15e9121f58c4)
            // $("#btnTestPost").on('click', function(e) {
            //    e.preventDefault();
            //    e.stopPropagation();
            //    let url = window.BaseUrlWebApi + "/Offerte/TestPost"
            //    getApi().fetchWithAuth("POST " + url, {
            //        body: JSON.stringify({
            //            intero: 1, 
            //            stringa: "pippo"
            //        })
            //    });
            //   
            //    return false;
            // });
            // $("#btnTestGet").on('click', function(e) {
            //     e.preventDefault();
            //     e.stopPropagation();
            //     let url = window.BaseUrlWebApi + "/Offerte/TestGet?intero=1"
            //     getApi().fetchWithAuth("GET " + url);
            //
            //     return false;
            // });
            // $("#btnTestDelete").on('click', function(e) {
            //     e.preventDefault();
            //     e.stopPropagation();
            //     let url = window.BaseUrlWebApi + "/Offerte/TestDelete?intero=1"
            //     getApi().fetchWithAuth("DELETE " + url);
            //
            //     return false;
            // });
        }

        await this.load();

        this._eventsRegistered = true;
    }

    private saveUndoValueEmail() {
        $("#txtEmail")
            .data("undo-value", $("#txtEmail").val() as string) // memorizzo il valore originale per ripristinarlo con "Annulla"
    }
    private restoreValueEmail() {
        $("#txtEmail").val($("#txtEmail").data("undo-value"));
    }
    private saveUndoValueCellulare() {
        $("#txtCellulare")
            .data("undo-value", $("#txtCellulare").val() as string); // memorizzo il valore originale per ripristinarlo con "Annulla"
        $("#ddlPrefisso")
            .data("undo-prefisso", $("#ddlPrefisso").val() as string);
    }
    private restoreValueCellulare() {
        $("#txtCellulare").val($("#txtCellulare").data("undo-value"));
        $("#ddlPrefisso").val($("#ddlPrefisso").data("undo-prefisso"));
    }
    public async load(): Promise<void> {
        this.theForm.reset();
        this.errorMessage.hideError();
        this.userInfo = await Auth.userInfo(true);
        if (!this.userInfo.isAuthenticated) {
            //TODO: mostrare messaggio di errore, tornare alla home
            UI.message(t("messages.unauthorizedAccess"), async function () {
                await gotoLogin();
            });
        } else {
            this.initializeHiddenFields(); // Inizializza lo stato dei campi nascosti
            await this.fillFormFields();
            this.addValidation();
            this.handleSubmit();
        }
    }

    /**
     * Inizializza correttamente i campi nascosti all'avvio, disabilitandoli e rimuovendo required
     */
    private initializeHiddenFields(): void {
        // Il form parte con le classi: nascita-ita, cittadinanza-ita, residenza-ita
        // Quindi i campi con hidden-nascita-ita, hidden-cittadinanza-ita, hidden-residenza-ita sono nascosti

        // Disabilita campi nascosti per nascita estera (nascosti quando nascita-ita)
        $('.hidden-nascita-ita :input')
            .prop('disabled', true)
            .prop('required', false);

        // Disabilita campi nascosti per cittadinanza estera (nascosti quando cittadinanza-ita)
        $('.hidden-cittadinanza-ita :input')
            .prop('disabled', true)
            .prop('required', false);

        // Disabilita campi nascosti per residenza estera (nascosti quando residenza-ita)
        $('.hidden-residenza-ita :input')
            .prop('disabled', true)
            .prop('required', false);
    }


    private handleSubmit() {
        if (this._eventsRegistered) return;

        this.theForm.addEventListener("submit", async event => {
            event.preventDefault();
            event.stopPropagation();

            const isUpdated = await this.updateProfile();
            if (!isUpdated) {
                return false;
            }

            return false;
        });
    }

    public async updateContattoEmail(contatto: Auth.Contatto): Promise<boolean> {
        await this.onVerifyEmailValidator();
        const emailInput = document.getElementById("txtEmail") as HTMLInputElement;
        if (!emailInput?.checkValidity()) {
            return false;
        }
        try {
            UI.showWait();
            const profile = await getApi().fetchWithAuth("POST /user/contact", {
                body: JSON.stringify({
                    ...contatto,
                    verificato: false,
                    callbackUrl: window.BaseUrlWeb + "Home/ConfirmEmailContact",
                })
            });
            let _ = UI.confirmOneButton("", t("messages.emailUpdatedSuccess")); //TODO: i18n
            // console.log("update profile:", profile);
            return true;
        } catch (error) {
            this.errorMessage.showError(handleError(error));
            return false;
        } finally {
            UI.hideWait();
        }
    }

    public async updateContattoCell(contatto: Auth.Contatto): Promise<boolean> {
        await this.onVerifyCellValidator();
        const contattoIn = document.getElementById("txtCellulare") as HTMLInputElement;
        if (!contattoIn?.checkValidity()) {
            await UI.confirmOneButton("", t("messages.mobileCannotBeEmpty"));
            return false;
        }
        try {
            UI.showWait();
            const profile = await getApi().fetchWithAuth("POST /user/contact", {
                body: JSON.stringify({
                    ...contatto,
                    verificato: false
                })
            }) as Auth.UserInfo;
            let verified = false;
            let annullato = false;
            let send = true;
            let showResend = false;
            let title = t("messages.verificaNumeroTelefono");
            let invalidTitle = t("messages.invalidOtpRetry");
            let idContatto = profile.contatti?.find((c: Auth.Contatto) => c.tipoContatto === "CELL")?.idContatto;
            try {
                while (!verified && !annullato) { 
                    let codice = "";
                    if (send)
                        await this.inviaOtp(profile.userId as string, idContatto as number);
                    
                    try {
                        codice = await UI.promptOtp(showResend ? invalidTitle : title, showResend);
                        send = false;
                        showResend = false;
                        if (await this.verificaOtp(profile.userId as string, idContatto as number, codice)) {
                            verified = true;
                            $("#txtCellIsVerified").val("S");
                        } else {
                            title = invalidTitle;
                            showResend = true;
                            send = false;
                            $("#txtCellIsVerified").val("N");
                        }
                    } catch (err) {
                        let error = err as Error;
                        switch (error.message as string) {
                            case "cancelled":
                                annullato = true;
                                break;
                            case "resend":
                                // attendi 5 secondi
                                UI.showWait();
                                await UI.delay(5000);
                                send = true;
                                showResend = false;
                                break;
                            default:
                                throw err;
                        }
                    }
                }
            } catch (err) {
                UI.confirmOneButton("", t("messages.otpVerificationError"));
            }
            this.setVerificaFeedbackCellulare();
            // show modal conferma OTP

            // let _ = UI.confirmOneButton("", "Il nuovo numero di cellulare è stato salvato. Ti abbiamo inviato un SMS per validarlo"); //TODO: i18n
            // console.log("update profile:", profile);
            return true;
        } catch (error) {
            this.errorMessage.showError(handleError(error));
            return false;
        } finally {
            UI.hideWait();
        }
    }
    private async inviaOtp(userId: string, idContatto: number): Promise<void> {
        let url = `${window.BaseUrlWebApi}Anagrafica/SendSmsOtp`;
        let qry = `userId=${userId}&contattoId=${idContatto}&mailUpListId=3`;
        let esito = await getApi().fetchWithAuth(`GET ${url}?${qry}`);
    }
    private async verificaOtp(userId: string, idContatto: number, codice: string): Promise<boolean> {
        let url = `${window.BaseUrlWebApi}Anagrafica/VerifySmsOtp`;
        let qry = `userId=${userId}&contattoId=${idContatto}&codice=${codice}`;
        let contatto: Auth.Contatto = await getApi().fetchWithAuth(`GET ${url}?${qry}`);
        return contatto.verificato;
    }

    public async updateProfile(fromOfferta: boolean | null = null): Promise<boolean> {
        this.onSubmitValidator();
        if (!this.theForm.checkValidity()) {
            this.theForm.classList.add('was-validated');
            this.theForm.removeValidFromEmptyOptionalFields();

            // Log di debug: stampa i campi invalidi
            const invalidFields = Array.from(this.theForm.querySelectorAll(':invalid'))
                .map((field: any) => ({
                    id: field.id || field.name,
                    name: field.name,
                    value: field.value,
                    required: field.required,
                    disabled: field.disabled,
                    type: field.type,
                    validationMessage: field.validationMessage,
                    hidden: field.offsetParent === null // verifica se è visibile
                }));

            console.error('Campi invalidi trovati:', invalidFields);
            console.error('Campi invalidi nascosti:', invalidFields.filter(f => f.hidden || f.disabled));

            // ✅ Trova il primo campo invalido visibile e posizionati su di esso
            const firstInvalidField = this.theForm.querySelector(':invalid:not([disabled])') as HTMLElement;
            if (firstInvalidField && firstInvalidField.offsetParent !== null) {
                // Scrolla fino al campo con un piccolo offset per mostrare meglio il contesto
                firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });

                // Dai focus al campo dopo lo scroll
                if (firstInvalidField instanceof HTMLInputElement ||
                    firstInvalidField instanceof HTMLSelectElement ||
                    firstInvalidField instanceof HTMLTextAreaElement) {
                    setTimeout(() => firstInvalidField.focus(), 300);
                }
            }

            return false;
        }

        // Anche in caso di successo, applica was-validated e rimuovi le spunte verdi dai campi vuoti
        this.theForm.classList.add('was-validated');
        this.theForm.removeValidFromEmptyOptionalFields();

        try {
            this.errorMessage.hideError();
            
            const profile = await getApi().fetchWithAuth("POST /user/profile", {
                body: JSON.stringify(this.mapFormDataToUserInfo())
            });

            if (!fromOfferta) {
                //this.errorMessage.showInfo("Profilo aggiornato con successo"); //TODO: i18n
                UI.confirmOneButton("", t("messages.profileUpdatedSuccess"));
            }

            // console.log("update profile:", profile);

            await Page.current.loadUserMenu("", true);

            return true;
        } catch (error) {
            const anagErr = error as AnagraficaError;
            let errMsg = "";
            
            if (anagErr && anagErr.hasErrorCode("CDFISC_EXISTS")) {
                errMsg = t("messages.codiceFiscaleAlreadyExists",{
                    cdFisc: this.theForm.CodiceFiscalePrivato.value,
                    telefono: window.Telefono,
                    mail: window.MailVendite
                });
            } else {
                errMsg = handleError(error);
            }
            
            this.errorMessage.showError(errMsg);
            // scroll on top
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
        }
    }


    private mapFormDataToUserInfo(): Auth.UserInfo {
        const formData = _.getFormData(this.theForm);


        // console.log("FormData:", formData);
        // Dati anagrafici base
        const userInfo: Auth.UserInfo = {
            userId: this.userInfo.userId,
            anagraficaId: this.userInfo.anagraficaId,
            email: this.userInfo.email,
            nome: formData.Nome,
            cognome: formData.Cognome,
            codiceFiscale: formData.CodiceFiscalePrivato,
            dataNascita: formData.DataNascita ? _.dateStringToDateUTC(formData.DataNascita) : undefined,
            sesso: formData.Sesso,
            idStatoNascita: Number(formData.StatoNascitaddl) || undefined,
            idComuneNascita: Number(formData.IdComuneNascita) || undefined,
            luogoNascitaEstero: formData.LuogoNascitaEstero,
            comuneNascita: formData.ComuneNascita,
            cittadinanza: formData.optCittadinanza === "option2" ? formData.Cittadinanza : undefined,
            contatti: [],
            recapiti: [],
            consensi: []
        };

        // Aggiungiamo i contatti se presenti
        if (formData.Email) {
            userInfo.contatti!.push({
                idContatto: Number(formData.IdContattoEMail) || undefined,
                tipoContatto: "MAIL",
                valore: formData.Email,
                verificato: formData.EmailVerificata === "S"
            });
        }

        if (formData.Telefono) {
            userInfo.contatti!.push({
                idContatto: Number(formData.IdContattoTel) || undefined,
                tipoContatto: "TEL",
                valore: formData.Telefono, verificato: false
            });
        }

        if (formData.Cellulare) {
            userInfo.contatti!.push({
                idContatto: Number(formData.IdContattoCell) || undefined,
                tipoContatto: "CELL",
                valore: formData.Cellulare,
                prefisso: formData.Prefisso,
                verificato: formData.CellulareVerificato === "S"
            });
        }

        // Aggiungiamo il recapito di residenza se presente
        if (formData.IdComune || formData.ComuneEstero) {
            const recapito = {
                idRecapito: Number(formData.IdIndirizzo) || undefined,
                tipoRecapito: "RESI",
                idStato: Number(formData.StatoResidenzaddl) || undefined
            } as any;

            if (Number(formData.StatoResidenzaddl) === 100) {
                // Residenza italiana
                recapito.idComune = Number(formData.IdComune) || undefined;
                recapito.comune = formData.Comune;
                recapito.idProvincia = Number(formData.IdProvincia) || undefined;
                recapito.provincia = formData.Provincia;
                recapito.cap = formData.Cap;
            } else {
                // Residenza estera
                recapito.comuneEstero = formData.ComuneEstero;
            }

            recapito.indirizzo = formData.Indirizzo;
            recapito.civico = formData.Civico;

            userInfo.recapiti!.push(recapito);
        }

        // Rimuoviamo array vuoti
        if (userInfo.contatti?.length === 0) delete userInfo.contatti;
        if (userInfo.recapiti?.length === 0) delete userInfo.recapiti;

        return userInfo;
    }

    private async fillFormFields() {
        const user = this.userInfo;
        $("#txtUserName").val(user.email as string);
        $("#txtNome").val(user.nome as string);
        $("#txtCognome").val(user.cognome as string);
        $("#txtCodiceFiscalePrivato").val(user.codiceFiscale as string);

        if (user.dataNascita) {
            const formattedDate = format(new Date(user.dataNascita), 'yyyy-MM-dd');
            console.info(formattedDate);
            $("#txtDataNascita").val(formattedDate);
        }

        if (user.sesso)
            $("#cboSesso").val(user.sesso);

        if (user.idStatoNascita) {
            $("#ddlStatoNasc").val(user.idStatoNascita!).trigger('change');
        }
        if (user.luogoNascitaEstero) {
            $("#txtLuogoNascitaEstero").val(user.luogoNascitaEstero as string);
        }
        if (user.idComuneNascita) {
            $("#txtIdComuneNascita").val(user.idComuneNascita!);
            await autocomplete.setAutocompleteValue("txtComuneNascita", user.comuneNascita as string);
        }

        if (user.cittadinanza) {
            // se valorizzata, è estera
            $("#optCittadinanzaEstera").trigger('click');
            $("#ddlCitta").val(user.cittadinanza);
        }

        // CONTATTI
        let contatti = user.contatti;
        const emailInput = document.getElementById("txtEmail") as HTMLInputElement;
        const cellInput = document.getElementById("txtCellulare") as HTMLInputElement;
        let $emailInputFeedback = $(emailInput).siblings('.invalid-feedback');
        let $cellInputFeedback = $(cellInput).siblings('.invalid-feedback');
        if (contatti) {
            const contattoMail = contatti.find(c => c.tipoContatto === "MAIL");
            if (contattoMail) {
                $("#txtEmail,#txtHiddenEmail").val(contattoMail.valore);
                $("#txtEmailIsVerified").val(contattoMail.verificato ? "S" : "N");
                $("#txtIdContattoEMail").val(contattoMail.idContatto as number);
                this.saveUndoValueEmail();
                this.setVerificaFeedbackEmail();

                // this.toggleVerificaEmail(!contattoMail.verificato);
                //
                //
                // if (!contattoMail.verificato) {
                //     // imposta validazione custom e mostra feedback immediato
                //     const message = "Indirizzo e-mail non verificato"; //TODO: i18n
                //     emailInput.setCustomValidity(message);
                //     $emailInputFeedback.text(message);
                //    
                //     $(emailInput).addClass('is-invalid');
                // } else {
                //     emailInput.setCustomValidity('');
                //     $(emailInput).removeClass('is-invalid');
                //     $emailInputFeedback.text("");
                // }
            } else {
                this.toggleVerifica("txtEmail", "txtEmail", true);
            }

            const contattoTel = contatti.find(c => c.tipoContatto === "TEL");
            if (contattoTel) {
                $("#txtTelefono").val(contattoTel.valore);
                $("#txtIdContattoTel").val(contattoTel.idContatto as number);
            }

            const contattoCell = contatti.find(c => c.tipoContatto === "CELL");
            if (contattoCell) {
                $("#txtCellulare,#txtHiddenCellulare").val(contattoCell.valore);
                $("#ddlPrefisso,#txtPrefisso").val(contattoCell.prefisso as string);
                $("#txtIdContattoCell").val(contattoCell.idContatto as number);
                $("#txtCellIsVerified").val(contattoCell.verificato ? "S" : "N");
                this.saveUndoValueCellulare();
                this.setVerificaFeedbackCellulare();

                // this.toggleVerificaCellulare(!contattoCell.verificato);
                //
                //
                // if (!contattoCell.verificato) {
                //     // imposta validazione custom e mostra feedback immediato
                //     const message = "Numero di cellulare non verificato"; //TODO: i18n
                //     cellInput.setCustomValidity(message);
                //     $cellInputFeedback.text(message);
                //
                //     $(cellInput).addClass('is-invalid');
                // } else {
                //     cellInput.setCustomValidity('');
                //     $(cellInput).removeClass('is-invalid');
                //     $cellInputFeedback.text("");
                // }
            } else {
                $("#ddlPrefisso,#txtPrefisso").val("0039");
                this.toggleVerifica("#txtCellulare", "#txtCellulare, #ddlPrefisso", true);
            }

        }


        // RECAPITI (RESIDENZA)
        let recapiti = user.recapiti;
        if (recapiti) {
            const recapitoRes = recapiti.find(r => r.tipoRecapito === "RESI");
            if (recapitoRes) {
                $("#txtIdIndirizzo").val(recapitoRes.idRecapito as number);
                $("#txtIdComune").val(recapitoRes.idComune as number);
                $("#txtComune").val(recapitoRes.comune as string);
                $("#txtComuneEstero").val(recapitoRes.comuneEstero as string);
                $("#txtIdProvincia").val(recapitoRes.idProvincia as number);
                $("#txtProvincia").val(recapitoRes.provincia as string);
                $("#txtCap").val(recapitoRes.cap as string);
                $("#txtIndirizzo").val(recapitoRes.indirizzo as string);
                $("#txtCivico").val(recapitoRes.civico as string);
                $("#ddlStatoRes").val(recapitoRes.idStato as number).trigger('change');
            }
        }

        // Aggiorna i requisiti dei campi in base a _strictValidation
        this.updateFieldsRequirements();
    }

    /**
     * Aggiorna l'obbligatorietà dei campi in base a _strictValidation e allo stato corrente del form
     */
    private updateFieldsRequirements(): void {
        if (this._strictValidation) {
            // Modalità strict: tutti i campi obbligatori (rispettando le sezioni visibili)
            $("#txtNome").prop("required", true);
            $("#txtCognome").prop("required", true);
            $("#txtCodiceFiscalePrivato").prop("required", true);
            $("#txtDataNascita").prop("required", true);
            $("#txtEmail").prop("required", true);
            $("#cboSesso").prop("required", true);
            $("#ddlStatoNasc").prop("required", true);
            $("#ddlStatoRes").prop("required", true);

            // Campi obbligatori su condizione - Nascita
            const statoNascita = $("#ddlStatoNasc").val() as string;
            if (statoNascita && statoNascita !== "") {
                if (statoNascita === "100") {
                    // Italia: comune di nascita obbligatorio
                    $("#txtComuneNascita").prop("required", true);
                    $("#txtLuogoNascitaEstero").prop("required", false);
                } else {
                    // Estero: luogo nascita estero obbligatorio
                    $("#txtComuneNascita").prop("required", false);
                    $("#txtLuogoNascitaEstero").prop("required", true);
                }
            } else {
                // Nessuno stato nascita selezionato
                $("#txtComuneNascita").prop("required", false);
                $("#txtLuogoNascitaEstero").prop("required", false);
            }

            // Campi obbligatori su condizione - Cittadinanza
            const cittadinanzaEstera = $("#optCittadinanzaEstera").prop("checked");
            if (cittadinanzaEstera) {
                $("#ddlCitta").prop("required", true);
            } else {
                $("#ddlCitta").prop("required", false);
            }

            // Campi obbligatori su condizione - Residenza
            const statoResidenza = $("#ddlStatoRes").val() as string;
            if (statoResidenza && statoResidenza !== "") {
                $("#txtIndirizzo").prop("required", true);

                if (statoResidenza === "100") {
                    // Italia: comune, provincia e cap obbligatori
                    $("#txtComune").prop("required", true);
                    $("#txtCap").prop("required", true);
                    $("#txtComuneEstero").prop("required", false);
                } else {
                    // Estero: solo comune estero obbligatorio
                    $("#txtComune").prop("required", false);
                    $("#txtCap").prop("required", false);
                    $("#txtComuneEstero").prop("required", true);
                }
            } else {
                // Nessuno stato residenza selezionato
                $("#txtIndirizzo").prop("required", false);
                $("#txtComune").prop("required", false);
                $("#txtCap").prop("required", false);
                $("#txtComuneEstero").prop("required", false);
            }
        } else {
            // Modalità non strict: controlli meno stringenti

            // Campi sempre obbligatori
            $("#txtNome").prop("required", true);
            $("#txtCognome").prop("required", true);
            $("#txtCodiceFiscalePrivato").prop("required", false);
            $("#txtEmail").prop("required", true);

            // Campi non obbligatori in modalità non strict
            $("#txtDataNascita").prop("required", false);
            $("#cboSesso").prop("required", false);
            $("#ddlStatoNasc").prop("required", false);
            $("#ddlStatoRes").prop("required", false);

            // Campi obbligatori su condizione - Nascita
            const statoNascita = $("#ddlStatoNasc").val() as string;
            if (statoNascita && statoNascita !== "") {
                // Se selezionato stato di nascita, il comune è obbligatorio
                if (statoNascita === "100") {
                    // Italia: comune di nascita obbligatorio
                    $("#txtComuneNascita").prop("required", true);
                    $("#txtLuogoNascitaEstero").prop("required", false);
                } else {
                    // Estero: luogo nascita estero obbligatorio
                    $("#txtComuneNascita").prop("required", false);
                    $("#txtLuogoNascitaEstero").prop("required", true);
                }
            } else {
                // Nessuno stato nascita selezionato
                $("#txtComuneNascita").prop("required", false);
                $("#txtLuogoNascitaEstero").prop("required", false);
            }

            // Campi obbligatori su condizione - Cittadinanza
            const cittadinanzaEstera = $("#optCittadinanzaEstera").prop("checked");
            if (cittadinanzaEstera) {
                // Cittadinanza estera selezionata: stato cittadinanza obbligatorio
                $("#ddlCitta").prop("required", true);
            } else {
                // Cittadinanza italiana
                $("#ddlCitta").prop("required", false);
            }

            // Campi obbligatori su condizione - Residenza
            const statoResidenza = $("#ddlStatoRes").val() as string;
            if (statoResidenza && statoResidenza !== "") {
                // Se selezionato stato di residenza, l'indirizzo è obbligatorio
                $("#txtIndirizzo").prop("required", true);

                if (statoResidenza === "100") {
                    // Italia: comune, provincia e cap obbligatori
                    $("#txtComune").prop("required", true);
                    $("#txtCap").prop("required", true);
                    $("#txtComuneEstero").prop("required", false);
                } else {
                    // Estero: solo comune estero obbligatorio
                    $("#txtComune").prop("required", false);
                    $("#txtCap").prop("required", false);
                    $("#txtComuneEstero").prop("required", true);
                }
            } else {
                // Nessuno stato residenza selezionato: nessun campo residenza obbligatorio
                $("#txtIndirizzo").prop("required", false);
                $("#txtComune").prop("required", false);
                $("#txtCap").prop("required", false);
                $("#txtComuneEstero").prop("required", false);
            }
        }
    }

    private toggleVerificaFeedback(verificato: boolean, inputSel: string, disableSel: string, message: string) {
        this.toggleVerifica(inputSel, disableSel, !verificato);
        const inputEl = document.querySelector(inputSel) as HTMLInputElement;
        let $inputFeedback = $(inputEl).siblings('.invalid-feedback');

        if (!verificato) {
            // imposta validazione custom e mostra feedback immediato
            //const message = "Numero di cellulare non verificato"; //TODO: i18n
            inputEl.setCustomValidity(message);
            $inputFeedback.text(message);

            $(inputEl).addClass('is-invalid');
        } else {
            inputEl.setCustomValidity('');
            $(inputEl).removeClass('is-invalid');
            $inputFeedback.text("");
        }
    }

    private toggleVerifica(inputSel: string, disableSel: string, toggle: boolean) {
        if (toggle) {
            $(disableSel).removeAttr("disabled");
        } else {
            $(disableSel).prop("disabled", true);
        }
        $(inputSel).toggleClass('not-verified',toggle); 
        let $group = $(inputSel).closest(".verifica-group");
        $group.find(".modifica").toggleClass("d-none", toggle);
        $group.find(".verifica").toggleClass("d-none", !toggle);
    }

    private toggleVerificaEmail(toggle: boolean) {
        this.toggleVerifica("#txtEmail", "#txtEmail", toggle);
    }

    private isCellulareVerified(): boolean {
        return $("#txtCellIsVerified").val() as string == "S"
    }
    
    private setVerificaFeedbackCellulare() {
        this.toggleVerificaFeedback(this.isCellulareVerified(),
            "#txtCellulare",
            "#txtCellulare, #ddlPrefisso",
            t("messages.phoneNotVerified"));
    }

    private setVerificaFeedbackEmail() {
        this.toggleVerificaFeedback($("#txtEmailIsVerified").val() as string == "S",
            "#txtEmail",
            "#txtEmail",
            t("messages.emailNotVerified"));
    }
    private toggleVerificaCellulare(toggle: boolean) {
        this.toggleVerifica("#txtCellulare", "#txtCellulare, #ddlPrefisso", toggle);
    }

    private addValidation() {
        const that = this;
        const form = this.theForm;
        // VALIDAZIONE FORM

        form.addEventListener('input', function (event) {
            form.classList.remove('was-validated');
        }, false);

        // VALIDAZIONE CAMPO CODICE FISCALE
        const cfValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const cf = ($(inputElement).val() as string).toUpperCase();

            // In modalità non-strict il CF non è obbligatorio:
            // se il campo è vuoto non eseguire nessun controllo
            if (!that._strictValidation && cf.trim().length === 0) {
                return { ok: true, error: "" };
            }

            const comuneData = $("#txtIdComuneNascita").data('select-item') || {} as any;
            const isValid = validateCodiceFiscale(cf);

            return {
                ok: isValid.ok,
                error: isValid.ok ? "" :
                    (!isValid.details.checkDigit || !isValid.details.format)
                        ? t("validation.invalidCodiceFiscale")
                        : t("validation.codiceFiscaleMismatch")
            }
        }

        const numTelValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const numTel = $(inputElement).val() as string;
            let isValid = numTel.trim().length == 0
                || (/^[0-9\s\+\(\)\-]+$/.test(numTel)
                    && numTel.trim().length >= 8 // almeno 8 caratteri numerici
                    && numTel.trim().length <= 20); // massimo 15 caratteri numerici

            return {
                ok: isValid,
                error: isValid ? ""
                    : t("validation.invalidPhoneNumber")
            }
        }
        const numCellValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            let numTel = $(inputElement).val() as string;
            //normalizza il numero di telefono rimuovendo spazi e trattini
            numTel = numTel.replace(/[\s\-\(\)a-zA-Z]/g, "");
            $(inputElement).val(numTel);

            let isValid = numTel.trim().length == 0
                || (/^[0-9\s\+\(\)\-]+$/.test(numTel)
                    && numTel.trim().length >= 8 // almeno 8 caratteri numerici
                    && numTel.trim().length <= 20); // massimo 15 caratteri numerici

            return {
                ok: isValid,
                error: isValid ? ""
                    : t("validation.invalidMobileNumber")
            }
        }

        const emailValidator = (inputElement: HTMLInputElement): validation.ValidationResult | void => {
            const email = $(inputElement).val() as string;
            
            if (email.trim().length == 0) return;  
            
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = emailRegex.test(email);

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.emailInvalidFormat")
            };
        }


        const validateCf = () => {
            validation.validate("txtCodiceFiscalePrivato", cfValidator)
        }
        const validateNumTelefono = () => {
            validation.validate("txtTelefono", numTelValidator);
        }

        const validateNumCellulare = () => {
            validation.validate("txtCellulare", numCellValidator);
        }

        const validateEmail = () => {
            validation.validate("txtEmail", emailValidator);
        }

        validation.setValidatorOnInput("txtCodiceFiscalePrivato", cfValidator);
        validation.setValidatorOn('change', "txtIdComuneNascita", validateCf);
        validation.setValidatorOnInput("txtNome", validateCf);
        validation.setValidatorOnInput("txtCognome", validateCf);
        validation.setValidatorOnInput("txtTelefono", validateNumTelefono);
        validation.setValidatorOnInput("txtCellulare", numCellValidator);
        validation.setValidatorOnInput("txtEmail", emailValidator);
        validation.setValidatorOn("changeDate", "txtDataNascita", validateCf);
        validation.setValidatorOnInput("cboSesso", validateCf);

        this.onSubmitValidator = async () => {
            validateCf();
            validateNumTelefono();
            validateNumCellulare();
            validateEmail();
            //TODO: aggiungere tutte le validazioni necessarie 
        }

        this.onVerifyEmailValidator = async () => {
            validateEmail();
        }

        this.onVerifyCellValidator = async () => {
            validateNumCellulare();
        }

    }

    private onSubmitValidator: () => void = async () => {
    }

    private onVerifyEmailValidator: () => void = async () => { }

    private onVerifyCellValidator: () => void = async () => { }

    private setStato(categ: "cittadinanza" | "residenza" | "nascita", optToDisplay: "ita" | "estero") {
        const optToHide = (optToDisplay === "ita") ? "estero" : "ita";

        // Abilita i campi della sezione da mostrare
        $(`.hidden-${categ}-${optToHide} :input`)
            .prop('disabled', false);

        this.theForm.classList.toggle(`${categ}-${optToDisplay}`, true);
        this.theForm.classList.toggle(`${categ}-${optToHide}`, false);

        // Disabilita i campi della sezione da nascondere e resetta i loro valori
        $(`.hidden-${categ}-${optToDisplay} :input`)
            .val("")
            .prop('disabled', true)
            .prop('required', false); // rimuove anche required per evitare errori di validazione su campi nascosti

    }

    private setCittadinanza(opt: "ita" | "estero") {
        this.setStato("cittadinanza", opt);
    }

    private setResidenza(opt: "ita" | "estero") {
        this.setStato("residenza", opt);
    }

    private setNascita(opt: "ita" | "estero") {
        this.setStato("nascita", opt);
    }

    private async aggiornaDatiDaCodiceFiscale(codiceFiscale: string): Promise<void> {
        const cf = codiceFiscale.toUpperCase().trim();
        const isValid = validateCodiceFiscale(cf);
        if (!isValid.ok) {
            // console.log("Codice fiscale non valido");
            return;
        }

        // Estrazione dei dati dal codice fiscale
        const birthDate = extractBirth(cf);
        const sesso: string = birthDate ? birthDate.sex : "";

        // Imposta la data di nascita usando Flatpickr
        if (birthDate) {
            const dataNascitaInput = document.querySelector("#txtDataNascita") as HTMLInputElement;
            if (dataNascitaInput && (dataNascitaInput as any)._flatpickr) {
                (dataNascitaInput as any)._flatpickr.setDate(birthDate.date, true);
            } else {
                // Fallback: formato HTML5 date input (yyyy-MM-dd)
                const formattedDate = format(birthDate.date, "yyyy-MM-dd");
                $("#txtDataNascita").val(formattedDate);
            }
        }

        $("#cboSesso").val(sesso);

        const codePlace: string = cf.slice(11, 15);
        console.info(codePlace);
        const idStatoNascita = await this.GetStatoIdByCode(codePlace);
        console.info(idStatoNascita);
        $("#ddlStatoNasc").val(idStatoNascita).trigger('change');
        $("#txtStatoNascitaId").val(idStatoNascita);
        if (idStatoNascita === 100) {
            // Se lo stato è Italia, cerco il comune
            const comuneData = await this.GetComuneByCode(codePlace);
            if (comuneData) {
                $("#txtIdComuneNascita").val(comuneData[0].IdComune);
                $("#txtComuneNascita").val(comuneData[0].Comune);

            } else {
                console.log("Comune non trovato per il codice fiscale:", cf);
            }
        }
    }

    private async GetStatoIdByCode(code: string): Promise<number> {
        return new Promise((resolve, reject) => {
            $.ajaxWithCredentials({
                url: window.BaseUrlWebApi + "Istat/GetStatoByCodiceAt?codiceAT=" + code,
                method: 'GET',
                //data: this.formData
            })
                .done(function (data, textStatus, jqXHR) {
                    resolve(data);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log(textStatus);
                    reject({ jqXHR, textStatus, errorThrown });
                })
                .always(function () {
                });
        });
    }

    private async GetComuneByCode(code: string): Promise<any> {
        return new Promise((resolve, reject) => {
            $.ajaxWithCredentials({
                url: window.BaseUrlWebApi + "Istat/GetComuneByCodiceCatastale?search=" + code,
                method: 'GET',
                //data: this.formData
            })
                .done(function (data, textStatus, jqXHR) {
                    resolve(data);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log(textStatus);
                    reject({ jqXHR, textStatus, errorThrown });
                })
                .always(function () {
                });
        });
    }


}